export default __webpack_public_path__ + "static/media/myjourney-bluetree-flower.c809f8a2.svg";